import React from "react";
import { brandAnalysisFeatures } from "../../data/mock";
import { Check, Target, MapPin, Rocket } from "lucide-react";

const icons = {
  "Brand Positioning": Target,
  "Local Competitive Edge": MapPin,
  "Go-to-Market Strategy": Rocket,
};

const BrandAnalysis = () => {
  return (
    <section className="py-24 px-4 bg-slate-900">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-400 text-sm font-semibold tracking-wider uppercase">
            What You Get
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 mb-4">
            A Complete Brand Playbook
          </h2>
          <p className="text-slate-400 max-w-3xl mx-auto">
            Everything you need to position your brand, understand your competition, 
            and launch effective marketing campaigns.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {brandAnalysisFeatures.map((feature, index) => {
            const IconComponent = icons[feature.title] || Target;
            return (
              <div
                key={index}
                className="bg-slate-800/50 border border-slate-700 rounded-2xl p-8 hover:border-emerald-500/50 transition-all duration-300 group"
              >
                <div className="w-14 h-14 bg-emerald-500/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-emerald-500/20 transition-colors">
                  <IconComponent className="w-7 h-7 text-emerald-400" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-slate-400 mb-6">{feature.description}</p>
                <ul className="space-y-3">
                  {feature.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                      <span className="text-slate-300 text-sm">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BrandAnalysis;
